module.exports = __webpack_public_path__ + "site/img/updataErcode.55a8cb4.png";


//////////////////
// WEBPACK FOOTER
// ./site/updataErcode.png
// module id = 154
// module chunks = 1